export default {
  FLOAT: /[^\d.-]/g,
  STRING_BETWEEN_BRACKETS: /\((.*)\)/,
  ALPHABET_AND_SPACE: /[^a-z ]/gi,
  HEX_TO_RGB: /^#([0-9a-f]{3}|[0-9a-f]{6})$/gi,
  ALPHABET_ONLY: /[^\w\s]/gi,
  ALPHANUMERIC_WITH_HASH: /[^A-Za-z0-9#]/g,
  RGBA: /^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i,
  NUMBERS_ONLY: /^-?[0-9]*(\.[0-9]*)?$/,
  DOUBLE_QUOTES: /['"]+/g,
  STRING_BETWEEN_COMMA_AND_BRACKET: /,(.*?)\)/,
  EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  NO_SPLCHAR_EXCEPT_HYPHEN: /[`!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?~\s]/,
  MOBILE_NUM:/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/
};
